import React from "react";
import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import { Banner } from "@hats-and-ladders/client-common";
import { useBanners } from "../hooks/useCMSData";

interface BannerDisplayProps {
  sx?: SxProps<Theme>;
}

export function BannerDisplay({ sx }: BannerDisplayProps) {
  const { banners } = useBanners();

  if (banners.length === 0) return null;

  return (
    <Box sx={sx}>
      {banners.map((banner) => (
        <Banner key={banner.id} banner={banner} />
      ))}
    </Box>
  );
}
